export default "__VITE_ASSET__47d3cdf0__"